/**
 * Utility functions for persisting and retrieving last login information
 * This info persists across logouts to remind users of their previous login method
 */

const LAST_LOGIN_KEY = 'lastLoginInfo';

/**
 * Save last login information to localStorage
 * @param {string} method - Login method: 'email' or 'google'
 * @param {string} email - User's email address
 */
export const saveLastLoginInfo = (method, email) => {
  try {
    if (!method || !email) {
      console.warn('Missing method or email for last login info');
      return;
    }

    const loginInfo = {
      method,
      email,
      timestamp: Date.now()
    };

    localStorage.setItem(LAST_LOGIN_KEY, JSON.stringify(loginInfo));
  } catch (error) {
    console.error('Failed to save last login info:', error);
  }
};

/**
 * Retrieve last login information from localStorage
 * @returns {{ method: string, email: string, timestamp: number } | null}
 */
export const getLastLoginInfo = () => {
  try {
    const stored = localStorage.getItem(LAST_LOGIN_KEY);
    if (!stored) {
      return null;
    }

    const loginInfo = JSON.parse(stored);

    // Validate the structure
    if (!loginInfo.method || !loginInfo.email) {
      return null;
    }

    return loginInfo;
  } catch (error) {
    console.error('Failed to retrieve last login info:', error);
    return null;
  }
};

/**
 * Clear last login information from localStorage
 * This should rarely be used - the info is meant to persist across logouts
 */
export const clearLastLoginInfo = () => {
  try {
    localStorage.removeItem(LAST_LOGIN_KEY);
  } catch (error) {
    console.error('Failed to clear last login info:', error);
  }
};
